<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 19">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width=".75" d="M14.25 9.6H3.75m6.75-3.75 3.75 3.75-3.75 3.75" />
  </svg>
</template>
